// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from './api';
import weekFilter from './filters/week';
import DateFilter from './filters/date';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// import style
import 'swiper/css/swiper.css';

Vue.use(VueAwesomeSwiper, /* { default options with global component } */);

Vue.prototype.$axios = axios;
Vue.filter('week', weekFilter);
Vue.filter('date', DateFilter);
Vue.config.productionTip = false;


// router.beforeEach((to, from, next) => {
//     if (to.meta.requireAuth) {
//         if (localStorage.getItem('isForkisslogin')) {
//             next();
//         } else {
//             next({
//                 path: '/login' //指向为你的登录界面
//             });
//         }
//     } else {
//         next();
//     }

//     if (to.fullPath === '/login') {
//         if (localStorage.getItem('isForkisslogin')) {
//             next({
//                 path: from.fullPath
//             });
//         } else {
//             next();
//         }
//     }
// });
/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});

window.vue = app;
// === 统一处理点击变色加透明度问题（用法：增加属性data-touch="true"） ===
// 点击时添加.active效果
document.body.addEventListener('touchstart', function (e) {
    let target = e.target;

    if (target.dataset.touch === 'true') {
        target.classList.add('touch-active');
    }
});

// 移动时判断触点是否在元素范围内
document.body.addEventListener('touchmove', function (e) {
    let target = e.target;
    let rect = target.getBoundingClientRect();
    if (target.dataset.touch === 'true') {
        // 移出元素时，取消active状态
        if (e.changedTouches[0].pageX < rect.left
                || e.changedTouches[0].pageX > rect.right
                || e.changedTouches[0].pageY < rect.top
                || e.changedTouches[0].pageY > rect.bottom) {
            target.classList.remove('touch-active');
        }
    }
});

// 触摸结束或取消时去掉效果
document.body.addEventListener('touchcancel', function (e) {
    let target = e.target;
    if(target.dataset.touch === 'true') {
        target.classList.remove('touch-active');
    }
});
document.body.addEventListener('touchend', function (e) {
    let target = e.target;
    if(target.dataset.touch === 'true') {
        target.classList.remove('touch-active');
    }
});



// WEBPACK FOOTER //
// ./src/main.js